export default "__VITE_ASSET__4JMvSlUn__"